import { config, mui, React, ts, ui } from '_core';

import { DraftParams } from './types';

type FormProps = {
  params: DraftParams;
  setParams: (_p: DraftParams) => void;

  frequency?: ts.enums.FREQUENCY_ENUM;
  universeCountries: string[];
  universeStartDate?: string;
  universeEndDate?: string;
};

const Form = ({
  params,
  setParams,
  frequency = null,
  universeStartDate = null,
  universeEndDate = null,
  universeCountries = [],
}: FormProps) => {
  const [snapshotDate, setSnapshotDate] = React.useState(params.end_date || universeEndDate);

  const [componentErrors, setComponentErrors] = React.useState([]);

  React.useEffect(() => {
    const data = {
      start_date: snapshotDate,
      end_date: snapshotDate,
      component_errors: componentErrors,
    };
    setParams({ ...params, ...data });
  }, [snapshotDate, componentErrors]);

  return (
    <mui.core.Box mt={4} mb={3}>
      <ui.SmartDateSelector
        label="Snapshot Date"
        value={snapshotDate}
        setValue={(date) => setSnapshotDate(date)}
        minDate={universeStartDate || config.features.start_date}
        maxDate={universeEndDate || config.features.end_date}
        frequency={frequency}
        countries={universeCountries}
        setExternalError={(e) => setComponentErrors(e ? [e] : [])}
      />
    </mui.core.Box>
  );
};

export default Form;
